module.exports = __webpack_public_path__ + "038fac040613d582598abc307c1106ce.svg";